import { useContext } from 'react';
import { Navigate } from 'react-router-dom';

import AuthContext from './AuthContext';

const ProtectedRoute = ({
  children,
  requiredRole,
}) => {
  const {
    loading,
    user,
    role,
    isNewUser,
  } = useContext(AuthContext);

  if (loading) {
    return null;
  }

  if (!user) {
    return (
      <Navigate
        to="/"
        replace
      />
    );
  }

  if (isNewUser) {
    return (
      <Navigate
        to="/welcome"
        replace
      />
    );
  }

  if (
    requiredRole &&
    role !== requiredRole
  ) {
    return (
      <Navigate
        to="/opportunity-calculator"
        replace
      />
    );
  }

  return children;
};

export default ProtectedRoute;